import {
  jb_publication_download_css_default
} from "./chunk.3KX7M644.js";
import {
  gsapWithCSS
} from "./chunk.PZPRGJID.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.UK6KU6OP.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-publication-download/jb-publication-download.ts
var JbPublicationDownload = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.withNewsletterSignup = false;
    this._firstPartyDataProcessing = false;
    this._formSubmitted = false;
    this._formValid = false;
    this._textWithCountdown = "";
  }
  async firstUpdated() {
    await this.updateComplete;
    if (this.autoStartAfterSeconds) {
      let counter = this.autoStartAfterSeconds;
      this._textWithCountdown = this.texts.downloadText.replace("{counter}", String(counter));
      counter -= 1;
      const intervalId = setInterval(() => {
        this._textWithCountdown = this.texts.downloadText.replace("{counter}", String(counter));
        counter -= 1;
        if (counter < 0) {
          clearInterval(intervalId);
        }
      }, 1e3);
      setTimeout(() => {
        if (this._downloadButton) {
          this._downloadButton.triggerClick();
        }
      }, this.autoStartAfterSeconds * 1e3);
    }
    if (this.skipDownloadPage) {
      const targetPage = this.renderRoot.querySelector(".newsletter-page");
      if (targetPage) {
        const componentObserver = new IntersectionObserver(
          async (entries, observer) => {
            if (entries[0].isIntersecting) {
              this._dispatchFormOpenEvent();
              observer.disconnect();
            }
          },
          {
            rootMargin: "0px"
          }
        );
        componentObserver.observe(this);
        this.renderRoot.querySelectorAll(".page").forEach((element) => {
          element.style.display = "none";
          element.style.opacity = "0";
        });
        targetPage.style.display = "initial";
        targetPage.style.opacity = "1";
      }
    }
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _dispatchFormOpenEvent() {
    let eventType = "newsletter";
    if (this.withNewsletterSignup && this.skipDownloadPage) {
      eventType = "email-for-download";
    }
    this.parentElement?.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          component_name: "publication-download",
          event: "ce_form",
          event_version: "v2",
          form_component: this._form,
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: this.link?.data.downloadFileName,
          form_type: eventType
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchFormSentEvent() {
    const eventInitDict = {
      detail: {
        component_name: "publication-download",
        event: "ce_form",
        event_version: "v2",
        form_step_name: "form sent",
        form_step_nr: "2",
        form_subject: this.link?.data.downloadFileName,
        form_type: "newsletter",
        optin_type: "single"
      },
      bubbles: true,
      composed: true
    };
    if (this.withNewsletterSignup) {
      eventInitDict.detail.first_party_data_processing = this._firstPartyDataProcessing;
    }
    if (this.withNewsletterSignup && this.skipDownloadPage) {
      eventInitDict.detail.form_type = "email-for-download";
    }
    this.parentElement?.dispatchEvent(new CustomEvent("jb-tracking", eventInitDict));
  }
  _download(e2) {
    this._tracking(e2);
    if (this.withNewsletterSignup) {
      this._transitionTo(".download-page", ".newsletter-page");
      this._dispatchFormOpenEvent();
    }
    if (!this.withNewsletterSignup && !this.autoStartAfterSeconds) {
      this._transitionTo(".download-page", ".success-page");
    }
  }
  _getContentSpacingProperties() {
    const type = this.classList.contains("in-overlay") ? "no-vertical-space" : void 0;
    return { colsMdUp: "none", horizontal: "full-width", type };
  }
  _subscribe(e2) {
    e2.preventDefault();
    if (!this._formValid || this._formSubmitted) return;
    this._formSubmitted = true;
    const form = this.shadowRoot?.querySelector("jb-form");
    const slottedInputs = form.querySelectorAll("jb-text-field, jb-checkbox");
    const additionalInputs = form.shadowRoot?.querySelectorAll("input");
    const formData = {};
    if (globalThis._satellite) {
      formData.marketingCloudVisitorID = globalThis._satellite.getVisitorId().getMarketingCloudVisitorID();
      formData.marketingCloudOrgID = globalThis._satellite.getVisitorId().marketingCloudOrgID;
    }
    Array.from([...slottedInputs, ...additionalInputs]).forEach((element) => {
      try {
        const name = element.getAttribute("name");
        if (element.tagName === "JB-CHECKBOX") {
          formData[name] = element.checkbox?.checked;
        } else {
          formData[name] = element.value;
        }
      } catch (err) {
      }
    });
    try {
      this._firstPartyDataProcessing = formData.newsletterAgree;
    } catch (err) {
    }
    fetch(this.formAction, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      redirect: "follow",
      body: JSON.stringify(formData)
    }).then((response) => {
      if (!response.ok) {
        this._transitionTo(".newsletter-page", ".error-page");
      }
      return response.json();
    }).then((data) => {
      if (data.success === true) {
        this._transitionTo(".newsletter-page", data.success ? ".success-page" : ".error-page");
      } else {
        this._transitionTo(".newsletter-page", ".error-page");
      }
      if (data.success === true) {
        this._dispatchFormSentEvent();
      }
    });
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "publication-download"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _transitionTo(page1, page2) {
    const el1 = this.renderRoot.querySelector(page1);
    const el2 = this.renderRoot.querySelector(page2);
    const timeline = gsapWithCSS.timeline({
      paused: true,
      defaults: { duration: 1 }
    }).to(el1, { opacity: 0, display: "none" }).to(el2, { display: "initial", opacity: 1 });
    timeline.restart();
  }
  render() {
    return ke`
      <section>
        <div class="image-wrapper">
          <jb-picture
            .alt=${this.picture.alt}
            .imgData=${this.picture.imgData}
            .lazy=${this.picture.lazy}
          ></jb-picture>
        </div>

        <div class="content-wrapper">
          <div class="download-page page">
            <h2>${this.texts.downloadTitle}</h2>
            ${this._textWithCountdown || this.texts.downloadText ? ke`<jb-richtext>${ae(this._textWithCountdown || this.texts.downloadText)}</jb-richtext>` : D}
            ${this.features ? ke` <jb-feature-list .features=${this.features}></jb-feature-list> ` : D}
            <jb-button-primary
              @jb-link:clicked=${this._download}
              .link=${this.link}
              data-download-button
            >
              ${this.texts.downloadButton}
            </jb-button-primary>
          </div>

          ${this.withNewsletterSignup ? ke`
                <div class="newsletter-page page">
                  <h2>${this.texts.downloadSuccessTitle}</h2>
                  <jb-richtext>${ae(this.texts.downloadSuccessText)}</jb-richtext>
                  ${this.features && this.skipDownloadPage ? ke` <jb-feature-list .features=${this.features}></jb-feature-list> ` : D}
                  <jb-form
                    action="/"
                    method="post"
                    formName="Newsletter Signup Form"
                    componentName="publication-download"
                    @jb-form:submit=${(e2) => {
      e2.detail.preventDefault();
      this._formValid = true;
      this._subscribe(e2);
    }}
                    @jb-tracking=${this._captureTracking}
                  >
                    <jb-text-field
                      requiredText=${this.texts.emailError}
                      emailErrorText=${this.texts.emailError}
                      label=${this.texts.emailPlaceholder}
                      name="email"
                      placeholder=${this.texts.emailPlaceholder}
                      type="email"
                    ></jb-text-field>
                    ${this.texts.agreement ? ke`
                          <jb-checkbox
                            afterCheckboxText=${this.texts.afterCheckboxText}
                            beforeCheckboxText=${this.texts.beforeCheckboxText}
                            requiredText=${this.texts.agreementRequiredText}
                            label=${this.texts.agreement}
                            name="newsletterAgree"
                            value="accepted"
                          ></jb-checkbox>
                        ` : D}
                    ${!this.texts.agreementRequiredText && this.texts.agreement && !this.withNewsletterSignup ? ke`
                          <jb-richtext .size=${"mini"}>
                            <p>${ae(this.texts.agreement)}</p>
                          </jb-richtext>
                        ` : D}
                    <jb-button-primary
                      @click=${this._subscribe}
                      name="submit"
                    >
                      ${this.texts.subscribeButton}
                    </jb-button-primary>
                  </jb-form>
                </div>
                <div class="success-page page">
                  <h2>
                    ${this.withNewsletterSignup && this.texts.successWithSubscriptionTitle && this._firstPartyDataProcessing ? ae(this.texts.successWithSubscriptionTitle) : ae(this.texts.successTitle)}
                  </h2>
                  <jb-richtext>
                    ${this.withNewsletterSignup && this.texts.successWithSubscriptionText && this._firstPartyDataProcessing ? ae(this.texts.successWithSubscriptionText) : ae(this.texts.successText)}
                  </jb-richtext>
                </div>

                <div class="error-page page">
                  <h2>${ae(this.texts.errorTitle)}</h2>
                  <jb-richtext>${ae(this.texts.errorText)}</jb-richtext>
                </div>
              ` : ke`
                <div class="success-page page">
                  <h2>${this.texts.downloadSuccessTitle}</h2>
                  <jb-richtext>${ae(this.texts.downloadSuccessText)}</jb-richtext>
                </div>
              `}
        </div>
      </section>
    `;
  }
};
JbPublicationDownload.styles = [reset_css_default, jb_publication_download_css_default];
__decorateClass([
  n({ type: Number })
], JbPublicationDownload.prototype, "autoStartAfterSeconds", 2);
__decorateClass([
  n({ type: Array })
], JbPublicationDownload.prototype, "features", 2);
__decorateClass([
  n()
], JbPublicationDownload.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "link", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "picture", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "skipDownloadPage", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "texts", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "withNewsletterSignup", 2);
__decorateClass([
  e("[data-download-button]")
], JbPublicationDownload.prototype, "_downloadButton", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_firstPartyDataProcessing", 2);
__decorateClass([
  e("jb-form")
], JbPublicationDownload.prototype, "_form", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_formSubmitted", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_formValid", 2);
__decorateClass([
  r2()
], JbPublicationDownload.prototype, "_textWithCountdown", 2);
JbPublicationDownload = __decorateClass([
  customElement("jb-publication-download")
], JbPublicationDownload);

export {
  JbPublicationDownload
};
